module.exports = __webpack_public_path__ + "img/mkw.201a82bd.svg";